export default "__VITE_ASSET__CSaIGjgr__"